import { EstimatesItem } from '@components/ArtBoard/Node/components/Estimates/EstimatesItem'
import { useClickOutside } from '@lib/hooks'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { getWidthByValueLength } from '@/utils/getWidthByValueLength'
import css from './Estimates.module.scss'

type Props = {
  nodeId: string
}

type InputWidth = Record<string, number> | null
type FocusedInput = Record<string, boolean> | null

export const Estimates: React.FC<Props> = ({ nodeId }) => {
  const [_, setInputWidth] = useState<InputWidth>(null)
  // @ts-expect-error @todo review a reason of set position
  const [positionX, setPositionX] = useState('16px')
  // const [estimatesWasOpen, setEstimatesWasOpen] = useState<boolean | null>(null)
  const [focusedInput, setFocusedInput] = useState<FocusedInput>(null)

  const containerRef = useRef<HTMLDivElement>(null)

  const clickOutside = useClickOutside<HTMLDivElement>(true, () => {
    setFocusedInput(null)
  })

  const isReadOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )

  // @todo review this later
  // useEffect(() => {
  //   if (containerRef.current) {
  //     const p = `${containerRef.current?.getBoundingClientRect().width / 2}px`
  //
  //     setPositionX(p)
  //   }
  // }, [inputWidth, estimates])

  // useEffect(() => {
  //   const ls = localStorage.getItem(ESTIMATES_WAS_OPEN)
  //
  //   setEstimatesWasOpen(ls === id ? true : null)
  // }, [isEqualToZero])

  const handleChangeWidth = (id: string, value: string) => {
    setInputWidth((prev) => ({
      ...prev,
      [id]: getWidthByValueLength(value),
    }))
  }

  return (
    <div
      {...clickOutside}
      className={css.container}
      ref={containerRef}
      style={{ right: `-${positionX}` }}
    >
      <EstimatesItem
        nodeId={nodeId}
        focusedInput={focusedInput}
        // estimatesWasOpen={!!estimatesWasOpen}
        onChangeInputWidth={handleChangeWidth}
        onFocusedInput={(v) => (!isReadOnly ? setFocusedInput(v) : null)}
        disabled={isReadOnly}
      />
    </div>
  )
}
